<script>
  import rpcjs from 'rpcjs';
  import {playAnimation} from './store.js';
  import {getContext, setContext} from 'svelte';
  import pages from './pages';
  import Preloader from './preloader';
  import {onMount} from 'svelte';
  import LiveChat from './chatPlugin.svelte';
  // import ContactUs from './contact_us/contact_us_btn.svelte';

  let PageLoaded = false;
  const {createUrlStore, title} = rpcjs.props;
  export let ssrUrl = '';
  setContext('APP', {url: createUrlStore(ssrUrl)});
  // Usage across descendants for SSR support
  const {url} = getContext('APP');
  const pathprefix = $url.pathname.match(/^\/[^\/]*/).at(0);

  onMount(setTimeout(()=>{
      PageLoaded=true;
  }, 100));
  title.set('Home');
  $:console.log(rpcjs);
  $:console.log('PageLoaded', PageLoaded);
</script>

<svelte:head>
  <title>Draper | {$title}</title>
</svelte:head>


<main>
  <div class="preloader">
    <Preloader />
  </div>
  <!-- {#if $api_init && PageLoaded} -->
    <div class="website">
      <svelte:component this={pages[pathprefix]} />
    </div>
  <!-- {/if} -->
  {#if ($playAnimation === false) && ( pathprefix != '/contact_us') }
    <!-- <div>
      <div>
        <ContactUs/>
      </div> -->
      <div>
        <LiveChat/>
      </div>
    <!-- </div> -->
  {/if}              
</main>


<style>
  .preloader {
    position: fixed;
    z-index: -10;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .website {
    background-color: white;
    z-index: 10;
    width: 100%;
    height: 100%;
  }
</style>
